var map = {
	"./G.png": "e7NG",
	"./R.png": "8PmN",
	"./Y.png": "3Ttt"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "oMav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lll ^\.\/.*\.png$
// module id = oMav
// module chunks = 0